import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class DiaIntegridad extends Component {
  componentDidMount() {
    window.startx();
  }
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Día de la Integridad</h2>
          </header>
          <div className="containerimagenblog">
          <img className="imagenBlog" src="images/Blog/portada4.jpg" alt="Simulacro 2023" />
          </div>
          <span className="containerblog">
              <div className="align justify">
                <p>
                  La ética como base del servicio público
                  El 9 de octubre, en el marco del Día de la Integridad, reflexionamos sobre la importancia de actuar 
                  con honestidad, responsabilidad y compromiso ético en cada una de nuestras acciones.

                </p>
                <p>
                 El verdadero cambio se gesta a partir de las acciones individuales de cada servidor público, que asume 
                 la integridad como parte esencial de su labor. Cada decisión guiada por la ética fortalece la confianza ciudadana 
                 y contribuye a construir instituciones más transparentes, justas y humanas.
                </p>
                <p>
                 En el Museo Interactivo El Rehilete, reafirmamos nuestro compromiso con una cultura institucional
                  basada en la ética, el respeto y la transparencia, convencidos de que la integridad no es solo un valor, sino 
                  una forma de trabajar y de servir a la sociedad.

                </p>
                <p>
                Recordemos que actuar con integridad significa hacer lo correcto, incluso cuando nadie nos ve. Es sembrar 
                confianza, inspirar con el ejemplo y garantizar que nuestras acciones contribuyan al bienestar común.
                La integridad se construye día a día, con cada decisión y con cada acto de servicio.
                </p>
            </div>
            <div>
              <div className="containerjuego">
                 <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default DiaIntegridad;